import { render } from "./KeywordsManagement.vue?vue&type=template&id=e5408df2&scoped=true&lang=pug"
import script from "./KeywordsManagement.js?vue&type=script&lang=js&external"
export * from "./KeywordsManagement.js?vue&type=script&lang=js&external"

import "./KeywordsManagement.vue?vue&type=style&index=0&id=e5408df2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5408df2"]])

export default __exports__